import React, { useState } from 'react';
import '../../styles/ServiceSelection.css';
import { initiateProject } from '../../services/api';

function ServiceSelection() {
  const [selectedService, setSelectedService] = useState(null);
  const [formData, setFormData] = useState({});

  const services = [
    { id: 1, name: 'Live Events', provider: 'In-House', description: 'Custom live event planning and execution.' },
    { id: 2, name: 'Web Development', provider: 'Nettech', description: 'Full-stack web solutions.' },
    { id: 3, name: 'Production Services', provider: 'New Age Productions', description: 'Video and audio production.' },
  ];

  const handleSelect = (service) => {
    setSelectedService(service);
    setFormData({ serviceId: service.id }); // Initialize with service ID
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await initiateProject(formData);
      setSelectedService(null);
      setFormData({});
      alert('Service request submitted successfully!');
    } catch (err) {
      alert('Failed to submit request. Please try again.');
    }
  };

  const renderQuestionnaire = () => {
    if (!selectedService) return null;

    switch (selectedService.name) {
      case 'Live Events':
        return (
          <form className="sp-request-form" onSubmit={handleSubmit}>
            <h3 className="sp-request-title">Live Events Request</h3>
            <input className="sp-request-input" name="eventName" placeholder="Event Name" onChange={handleInputChange} required />
            <input className="sp-request-input" name="date" type="date" onChange={handleInputChange} required />
            <input className="sp-request-input" name="venue" placeholder="Venue" onChange={handleInputChange} required />
            <input className="sp-request-input" name="attendees" type="number" placeholder="Expected Attendees" onChange={handleInputChange} required />
            <select className="sp-request-select" name="eventType" onChange={handleInputChange} required>
              <option value="">Select Event Type</option>
              <option value="conference">Conference</option>
              <option value="concert">Concert</option>
              <option value="wedding">Wedding</option>
              <option value="other">Other</option>
            </select>
            <textarea className="sp-request-textarea" name="details" placeholder="Event Details (e.g., theme, special requirements)" onChange={handleInputChange} required />
            <input className="sp-request-input" name="budget" type="number" placeholder="Budget ($)" onChange={handleInputChange} required />
            <button className="sp-request-btn" type="submit">Submit Request</button>
          </form>
        );
      case 'Web Development':
        return (
          <form className="sp-request-form" onSubmit={handleSubmit}>
            <h3 className="sp-request-title">Web Development Request</h3>
            <input className="sp-request-input" name="projectName" placeholder="Project Name" onChange={handleInputChange} required />
            <select className="sp-request-select" name="websiteType" onChange={handleInputChange} required>
              <option value="">Select Website Type</option>
              <option value="ecommerce">E-commerce</option>
              <option value="portfolio">Portfolio</option>
              <option value="business">Business</option>
              <option value="blog">Blog</option>
            </select>
            <input className="sp-request-input" name="domain" placeholder="Desired Domain (if any)" onChange={handleInputChange} />
            <textarea className="sp-request-textarea" name="features" placeholder="Required Features (e.g., login, payment gateway)" onChange={handleInputChange} required />
            <input className="sp-request-input" name="deadline" type="date" placeholder="Preferred Deadline" onChange={handleInputChange} required />
            <input className="sp-request-input" name="budget" type="number" placeholder="Budget ($)" onChange={handleInputChange} required />
            <textarea className="sp-request-textarea" name="designPrefs" placeholder="Design Preferences (e.g., colors, style)" onChange={handleInputChange} />
            <button className="sp-request-btn" type="submit">Submit Request</button>
          </form>
        );
      case 'Production Services':
        return (
          <form className="sp-request-form" onSubmit={handleSubmit}>
            <h3 className="sp-request-title">Production Services Request</h3>
            <input className="sp-request-input" name="projectName" placeholder="Project Name" onChange={handleInputChange} required />
            <select className="sp-request-select" name="productionType" onChange={handleInputChange} required>
              <option value="">Select Production Type</option>
              <option value="video">Video</option>
              <option value="audio">Audio</option>
              <option value="liveStream">Live Stream</option>
            </select>
            <input className="sp-request-input" name="duration" type="number" placeholder="Duration (minutes)" onChange={handleInputChange} required />
            <textarea className="sp-request-textarea" name="content" placeholder="Content Description (e.g., script outline)" onChange={handleInputChange} required />
            <input className="sp-request-input" name="date" type="date" placeholder="Production Date" onChange={handleInputChange} required />
            <input className="sp-request-input" name="budget" type="number" placeholder="Budget ($)" onChange={handleInputChange} required />
            <textarea className="sp-request-textarea" name="equipment" placeholder="Special Equipment Needs" onChange={handleInputChange} />
            <button className="sp-request-btn" type="submit">Submit Request</button>
          </form>
        );
      default:
        return null;
    }
  };

  return (
    <div className="sp-service-selection">
      <h2 className="sp-service-title">Select a Service</h2>
      <div className="sp-service-grid">
        {services.map((service) => (
          <div key={service.id} className="sp-service-card">
            <h3 className="sp-service-card-title">{service.name}</h3>
            <p className="sp-service-card-provider">{service.provider}</p>
            <p className="sp-service-card-desc">{service.description}</p>
            <button className="sp-service-btn" onClick={() => handleSelect(service)}>Select</button>
          </div>
        ))}
      </div>
      {renderQuestionnaire()}
    </div>
  );
}

export default ServiceSelection;